import React, { useState } from "react";
// import TextField from '@material-ui/core/TextField';
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import AppBar from "./../Components/header/index";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
// import SignInButton from "../../button/globleButtons";
import AppProvider from "./../Components/bootstrap/index";
// import InputBase from "@material-ui/core/InputBase";
import {useRedirect} from "react-admin";
// import CancleAppointmentrequest from "./CancleAppointmentRequest";
import { Box } from "@material-ui/core";
// import SearchIcon from '@material-ui/icons/Search';

// import SearchBar from 'material-ui-search-bar'
const useStyles = makeStyles(theme => ({
  // '@global': {
  //   body: {
  //     backgroundColor: theme.palette.common.white,
  //   },
  // },
  formControl: {
    margin: theme.spacing(1),
  },
  paper: {
    // marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height:15
  },
  avatar: {
    margin: 10,
    width: 300,
    height: 60,
    // margin: theme.spacing(1),
    backgroundColor: 'white',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(5),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  TextField:{
    marginTop:"8%",
    backgroundColor:"#ffffff"
  },
  coverBackgroundContainer: {
    backgroundColor:"#F7F8F9",
    height: "100vh",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginTop:"5%",
    alignItems: "center",
    paddingLeft:"4%",
    paddingRight:"4%",
    paddingTop:"30px",
    width:"100%"
  
   
  },
  
}));


const Option = props => {
    const redirect=useRedirect()
  const [Click] = useState("false");
  const [Clicks ] = useState("false");
  console.log("***Props*****", Click);
  console.log("***Props*****", Clicks);
//   console.log("***Props*****", setClicks);
  const classes = useStyles();

  const handleClick1=()=>{
    console.log("clivkfssinfs")
    return(
        redirect('/UpcomingAppointments')
    )
}
  const handleClick2=()=>{
    
    return(
      redirect('/PreviousAppointments')
    )
}
 
const handleClick=()=>{
  console.log("notification")
  return(
     
    alert("notification")
  )
}

  return (
    <div className={classes.coverBackgroundContainer}>
     
      
      <Container component="main" maxWidth="xs" style={{ }}>
      <Box height="50%">
          <Button
              variant="contained"
              color="primary"
              type="submit"
              onClick={handleClick1}
              style={{ width: "100%",height:"70px"}}
            >
              Upcoming Appointments
          </Button>
          </Box> 
            <Paper >
          <Button
        //   style={{ height: "15%",width:"" }}
              variant="contained"
              color="primary"
              type="submit"
              style={{ marginTop: "-5%" ,width: "100%",height:"70px"}}
              onClick={handleClick2}
              
            >
              Previous Appointments
          </Button>
            </Paper>
            <Paper >
          <Button
              variant="contained"
              color="primary"
              type="submit"
              style={{ marginTop: "5%",width: "100%",height:"70px" }}
              onClick={handleClick}
              
            >
              Notifications
          </Button>
            </Paper>
        <AppProvider>
          <AppBar />
        </AppProvider>
      </Container>
    </div>
  );
};
export default Option;
